import { Alert, Grid, Stack, TextField, Typography } from '@mui/material';
import React, { useState } from 'react'
import styled from 'styled-components';
import LoadingButtonStyled from '../../../atoms/v2/LoadingButton';
import _ from 'lodash';
import { ReactComponent as CuponSVG } from "../../../../assets/svg/cupon.svg";

export enum FormDiscountTicketErrorCodes {
    INVALID_CODE = "INVALID_CODE"
}

const FormDiscountTicket = (props: IFormDiscountTicketProps) => {
    const [invalidCode, setInvalidCode] = useState<{ code: string; } | undefined>(undefined);
    const [code, setCode] = useState('');
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleOnSubmit = async () => {
        try {
            setInvalidCode(undefined);
            setIsLoading(true);
            await props.onSubmit(code);
        } catch (error) {
            switch (error) {
                case FormDiscountTicketErrorCodes.INVALID_CODE:
                    setInvalidCode({ code: code });
                    break;
                default:
                    setInvalidCode(undefined);
                    break;
            }
        } finally {
            setCode('');
            setIsLoading(false);
        }
    }
    return (
        <Stack spacing={5}>
            <img style={{
                width: '100%',
                borderRadius: 20,
                alignSelf: 'center'
            }} src={require("../../../../assets/images/cupon.jpg")} />
            <Stack spacing={2}>
                <Typography variant='body1' textAlign='center'>
                    Paga con tarjeta de crédito o débito
                </Typography>
                <Grid container spacing={0.5} maxWidth={230} alignSelf='center'>
                    <Grid xs={3} item>
                        <div style={{ height: 25 }}>
                            <img style={{ height: '100%', width: '100%', objectFit: 'contain' }} src="visa.png" />
                        </div>
                    </Grid>
                    <Grid xs={3} item >
                        <div style={{ height: 25 }}>
                            <img style={{ height: '100%', width: '100%', objectFit: 'contain' }} src="mastercard.png" />
                        </div>

                    </Grid>
                    <Grid xs={3} item>
                        <div style={{ height: 25 }}>
                            <img style={{ height: '100%', width: '100%', objectFit: 'contain' }} src="american-express.png" />
                        </div>

                    </Grid>
                    <Grid xs={3} item>
                        <div style={{ height: 25 }}>
                            <img style={{ height: '100%', width: '100%', objectFit: 'contain' }} src="diners-club.png" />
                        </div>
                    </Grid>
                </Grid>
            </Stack>
            <Stack spacing={2}>
                {
                    invalidCode !== undefined && (
                        <Alert severity="error">
                            El cupón {invalidCode.code} es inválido.
                        </Alert>
                    )
                }
                <CssTextField
                    value={code}
                    onChange={(event) => {
                        const deburred = _.deburr(event.target.value);
                        const camelCased = _.camelCase(deburred);
                        const text = _.toUpper(camelCased);
                        setCode(text);
                    }}
                    label="Cupón de descuento"
                    variant="outlined"
                    InputProps={{
                        endAdornment: <CuponSVG width={30} height={30} fill='#737373' style={{ marginLeft: 10 }} />
                    }}
                    helperText='Si no tienes cupón, no completes'
                />
            </Stack>
            <LoadingButtonStyled
                loading={isLoading}
                onClick={handleOnSubmit}>
                Siguiente
            </LoadingButtonStyled>
        </Stack>
    );
}


export { FormDiscountTicket }


const CssTextField = styled(TextField)({
    '& label.Mui-focused': {
        color: '#32b0ea',
    },
    '& .MuiOutlinedInput-root': {
        borderRadius: 15,
        '&:hover fieldset': {
            borderColor: '#32b0ea',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#32b0ea',
        },
    },
});